import React from 'react';

import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import { FlightSearchBarActionType } from '@contexts/searchbar/types/flight';
import useSearchbar from '@contexts/searchbar';

import { StyledCheckbox } from './styled';

const DirectFlight = () => {
  const {
    state: { flight: state },
    dispatch,
  } = useSearchbar();

  const handleChange = (event: CheckboxChangeEvent) => {
    dispatch({
      type: FlightSearchBarActionType.SET_IS_DIRECT_FLIGHT,
      payload: event.target.checked,
    });
  };

  return (
    <StyledCheckbox checked={state.isDirectFlight} onChange={handleChange}>
      Aktarmasız Uçuşlar
    </StyledCheckbox>
  );
};

export default DirectFlight;
